import { defineComponent } from 'vue';
import useTransactionsStore from '@/store/modules/transactions';
import { useAuthStore } from '@/store/modules/auth';
import { numberFormat } from '@/utils/helpers';
import { storeToRefs } from 'pinia';
export default defineComponent({
    name: 'PendingDepositMobile',
    setup() {
        const transactionsStore = useTransactionsStore();
        const { transferFound, selectedCrypto, selectedCryptoAmount, cryptoTransferSent, collection, } = storeToRefs(transactionsStore);
        const authStore = useAuthStore();
        const { user } = storeToRefs(authStore);
        return {
            transferFound,
            selectedCrypto,
            selectedCryptoAmount,
            cryptoTransferSent,
            numberFormat,
            user,
            collection,
        };
    },
});
